import { Capacitor } from "@capacitor/core";
import { SecureStorage } from "@aparajita/capacitor-secure-storage";

// Native (Capacitor) bearer-token store. On iOS the value lives in the Keychain; on
// Android in Keystore-backed encrypted storage (AES-GCM). NEVER localStorage/plaintext.
// On web these helpers are no-ops — the web/PWA keeps the existing HttpOnly cookie session.

const TOKEN_KEY = "molaroo.auth.token";
let cachedToken = null;

export const isNative = () => Capacitor.isNativePlatform();

export function getCachedToken() {
  return cachedToken;
}

// Hydrate the in-memory token from OS secure storage. Call once at app start (and it is
// safe to call again). No-op on web.
export async function loadToken() {
  if (!isNative()) return null;
  try {
    const v = await SecureStorage.get(TOKEN_KEY);
    cachedToken = typeof v === "string" ? v : null;
  } catch {
    cachedToken = null;
  }
  return cachedToken;
}

export async function setToken(token) {
  if (!isNative()) return;
  cachedToken = token || null;
  try {
    if (token) await SecureStorage.set(TOKEN_KEY, token);
    else await SecureStorage.remove(TOKEN_KEY);
  } catch {
    /* ignore secure-storage errors; request will 401 and route to login */
  }
}

export async function clearToken() {
  cachedToken = null;
  if (!isNative()) return;
  try {
    await SecureStorage.remove(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}
